var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.propDialogObject
    ? _c(
        "el-dialog",
        {
          staticClass: "login-force-out-sure-dialog",
          attrs: {
            title:
              (_vm.validUserInfo.validIdentityName
                ? _vm.validUserInfo.validIdentityName
                : "") + "人脸拍照验证强制签退",
            visible: _vm.dialogVisible,
            width: "600px",
            "before-close": _vm.closeDialog
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "ruleForm",
              staticClass: "demo-ruleForm",
              attrs: {
                model: _vm.formObject,
                rules: _vm.rules,
                "label-width": "85px"
              },
              nativeOn: {
                submit: function($event) {
                  $event.preventDefault()
                }
              }
            },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "c-desc-form-item",
                  attrs: { label: "说明", prop: "operationDescription" }
                },
                [
                  _c("el-input", {
                    staticClass: "el_textarea",
                    attrs: {
                      type: "textarea",
                      placeholder: "请输入说明",
                      autosize: { minRows: 3 },
                      maxlength: "50",
                      "show-word-limit": ""
                    },
                    model: {
                      value: _vm.formObject.operationDescription,
                      callback: function($$v) {
                        _vm.$set(_vm.formObject, "operationDescription", $$v)
                      },
                      expression: "formObject.operationDescription"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "task-type-form-item",
                  attrs: { label: "拍照方式", prop: "taskType", required: "" }
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      on: { change: _vm.changeTaskType },
                      model: {
                        value: _vm.formObject.taskType,
                        callback: function($$v) {
                          _vm.$set(_vm.formObject, "taskType", $$v)
                        },
                        expression: "formObject.taskType"
                      }
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [
                        _vm._v("电脑拍照")
                      ]),
                      _c("el-radio", { attrs: { label: 2 } }, [
                        _vm._v("先锋版APP/小程序扫码拍照")
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  class: _vm.formObject.taskType == 2 ? "m-task-app-photo" : "",
                  attrs: {
                    label: _vm.formObject.taskType == 1 ? "确认拍照" : "",
                    prop: "taskPhotoUrl"
                  }
                },
                [
                  _vm.formObject.taskType == 1
                    ? [
                        _c(
                          "div",
                          { staticClass: "c-task-photo" },
                          [
                            _c(
                              "div",
                              { staticClass: "c-task-photo-content" },
                              [
                                _c("div", { staticClass: "c-task-photo-box" }, [
                                  _c("div", { staticClass: "scanning-photo" }, [
                                    _c("div", {
                                      attrs: { id: "signUserTaskBox" }
                                    })
                                  ])
                                ]),
                                !_vm.isTasking
                                  ? _c("el-image", {
                                      staticClass: "task-photo-img",
                                      attrs: {
                                        src: _vm.formObject.taskPhotoUrl
                                      }
                                    })
                                  : _vm._e(),
                                _c("p", { staticClass: "c-task-desc-box" }, [
                                  _vm._v(" 注意："),
                                  _c("br"),
                                  _vm._v(
                                    " 1、请" +
                                      _vm._s(
                                        _vm.validUserInfo
                                          ? _vm.validUserInfo.validIdentityName
                                          : ""
                                      )
                                  ),
                                  _c("span", [
                                    _vm._v(
                                      "【" +
                                        _vm._s(
                                          _vm.validUserInfo
                                            ? _vm.validUserInfo
                                                .validUserRealName
                                            : ""
                                        ) +
                                        "】"
                                    )
                                  ]),
                                  _vm._v(
                                    "，将人脸放在摄像框内，拍摄清晰、完整面部照片，比对成功，可强制签退 "
                                  ),
                                  _c("br"),
                                  _vm._v("2、强制签退将导致学员"),
                                  _c("span", { staticClass: "c-text-red" }, [
                                    _vm._v("学时无效")
                                  ]),
                                  _vm._v(
                                    "，" +
                                      _vm._s(
                                        _vm.validUserInfo
                                          ? _vm.validUserInfo.validIdentityName
                                          : ""
                                      ) +
                                      "的签退照片将作为凭证显示! "
                                  )
                                ])
                              ],
                              1
                            ),
                            _vm.isShowTaskButton
                              ? _c(
                                  "el-button",
                                  {
                                    staticClass: "reset-photo-btn",
                                    attrs: {
                                      type: "text",
                                      plain: "",
                                      size: "medium",
                                      loading: _vm.isTaskLoading
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.takeSignInPhoto()
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.isTasking ? "立即拍照" : "重新拍照"
                                      )
                                    )
                                  ]
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ]
                    : [
                        _c(
                          "div",
                          {
                            staticClass: "c-task-photo-content",
                            class:
                              _vm.formObject.taskType == 1
                                ? ""
                                : "c-task-photo-qr-content"
                          },
                          [
                            _c("div", { staticClass: "c-task-photo-box" }, [
                              _c(
                                "div",
                                { staticClass: "qr-scanning-photo" },
                                [
                                  _c("QrCodeLogo", {
                                    ref: "qrSignCodeLogoBox",
                                    attrs: {
                                      content: _vm.qrCodeContent,
                                      logoUrl: _vm.propDialogObject.item.logoImg
                                        ? _vm.propDialogObject.item.logoImg
                                        : _vm.logoImg,
                                      qrCodeWidth: 175,
                                      qrCodeHeight: 175,
                                      opts: _vm.opts
                                    }
                                  })
                                ],
                                1
                              )
                            ]),
                            _c(
                              "p",
                              {
                                staticClass: "c-task-desc-box",
                                class:
                                  _vm.formObject.taskType == 1
                                    ? ""
                                    : "c-task-desc-right-box"
                              },
                              [
                                _vm._v(" 注意："),
                                _c("br"),
                                _vm._v(
                                  " 1、请" +
                                    _vm._s(_vm.validUserInfo.validIdentityName)
                                ),
                                _c("span", [
                                  _vm._v(
                                    "【" +
                                      _vm._s(
                                        _vm.validUserInfo.validUserRealName
                                      ) +
                                      "】"
                                  )
                                ]),
                                _vm._v(
                                  "，将人脸放在摄像框内，拍摄 清晰、完整面部照片，比对成功，可强制签退 "
                                ),
                                _c("br"),
                                _vm._v(
                                  "2、强制签退将导致学员学时无效，" +
                                    _vm._s(
                                      _vm.validUserInfo.validIdentityName
                                    ) +
                                    "的签退照片将作为凭证显示! "
                                )
                              ]
                            )
                          ]
                        )
                      ]
                ],
                2
              ),
              _c(
                "div",
                {
                  staticClass: "icon-text",
                  class: [
                    "icon-text" + _vm.iconTextState,
                    _vm.formObject.taskType == 1 ? "" : "icon-text-qr"
                  ]
                },
                [
                  _c("img", { attrs: { src: _vm.iconImage } }),
                  _vm._v(" " + _vm._s(_vm.iconText) + " ")
                ]
              )
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                { attrs: { size: "medium" }, on: { click: _vm.closeDialog } },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    size: "medium",
                    disabled: _vm.isSureButtonDisDisable
                  },
                  on: { click: _vm.handleSure }
                },
                [_vm._v("确定")]
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }